import 'arrive';
import Swiper from 'swiper/bundle';

function dismissPageLoader() {
  const loader = document.getElementById('page-loader');
  if (loader) loader.classList.add('is-hidden');
}

document.arrive('.block-hero-slider', { existing: true }, function (el) {
  const container = el.querySelector('.hero-swiper');
  if (!container || container.dataset.swiperInitialized === 'true') return;

  container.dataset.swiperInitialized = 'true';

  // Loader: aspetta il primo video, fallback 5s
  const video = el.querySelector('.hero-slide__video');
  if (video) {
    const timeout = setTimeout(dismissPageLoader, 5000);
    if (video.readyState >= 3) {
      clearTimeout(timeout);
      dismissPageLoader();
    } else {
      video.addEventListener('canplay', () => {
        clearTimeout(timeout);
        dismissPageLoader();
      }, { once: true });
    }
  } else {
    dismissPageLoader();
  }

  const nextEl = container.querySelector('.swiper-button-next, .button-next');
  const prevEl = container.querySelector('.swiper-button-prev, .button-prev');

  // Configurazione Animazione Premium
  const CONFIG = {
    duration: 1200, // Unica durata gestita da Swiper per coerenza
    easing: 'cubic-bezier(0.25, 1, 0.5, 1)', // Out-Quart: parte veloce, finisce morbidissimo
  };

  new Swiper(container, {
    slidesPerView: 1,
    effect: 'creative',
    speed: CONFIG.duration,
    loop: true,
    allowTouchMove: true,
    watchSlidesProgress: true, // Fondamentale per animazioni custom
    creativeEffect: {
      prev: {
        shadow: true,
        translate: ['-20%', 0, -1], // Effetto parallasse: lo slide che esce si muove meno
        opacity: 0.5,
      },
      next: {
        translate: ['100%', 0, 0], // Lo slide che entra copre totalmente
      },
    },
    navigation: {
      nextEl: nextEl || undefined,
      prevEl: prevEl || undefined,
    },
    on: {
      beforeInit(s) {
        // Impostiamo l'easing via CSS sul wrapper per non sovrascrivere ogni volta
        s.wrapperEl.style.transitionTimingFunction = CONFIG.easing;
      },
      slideChangeTransitionStart(s) {
        // Gestione classi per animazioni CSS interne (es. testi che appaiono)
        s.slides.forEach(slide => slide.classList.remove('is-active'));
        s.slides[s.activeIndex].classList.add('is-active');
      }
    },
  });
});